import { forwardRef } from "react"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { ButtonLink } from "@/shared/ui/ButtonLink"
import { useNbrAuth } from "@/app/auth/useNbrAuth"
import { CABINET_ENTRY_PATH } from "@/widgets/cabinet/cabinetNav"
import { isNavItemActive } from "./navActiveMatchers"
import { buildSiteNavItems } from "./siteNav"

export type NavbarMobileMenuProps = {
  id: string
  ariaLabel: string
  /** Отступ сверху под фиксированную шапку: её высота меняется при скролле. */
  topClass: string
  onItemClick: () => void
}

export const NavbarMobileMenu = forwardRef<HTMLDivElement, NavbarMobileMenuProps>(
  ({ id, ariaLabel, topClass, onItemClick }, ref) => {
    const { t } = useTranslation()
    const { pathname } = useLocation()
    const auth = useNbrAuth()
    const links = buildSiteNavItems(auth.isLibrarian)

    return (
      <div
        ref={ref}
        id={id}
        className={`xl:hidden fixed ${topClass} left-0 right-0 z-40 max-h-[calc(100vh-4rem)] overflow-y-auto bg-lib-card border-t border-b border-lib-border shadow-lg px-6 py-4 flex flex-col gap-1`}
        role="navigation"
        aria-label={ariaLabel}
      >
        {links.map((link) => (
          <ButtonLink
            key={link.key}
            to={link.to}
            variant="navMobile"
            className="nav-menu-link !after:hidden"
            isActive={isNavItemActive(link.key, pathname)}
            onClick={onItemClick}
          >
            {t(`nav.${link.key}`)}
          </ButtonLink>
        ))}
        {auth.isAuthenticated ? (
          <div className="mt-3 pt-3 border-t border-lib-border flex flex-col gap-1">
            <ButtonLink to={CABINET_ENTRY_PATH} variant="navMobile" className="nav-menu-link !after:hidden" onClick={onItemClick}>
              {t("nav.account")}
            </ButtonLink>
            <ButtonLink to="/account/profile" variant="navMobile" className="nav-menu-link !after:hidden" onClick={onItemClick}>
              {t("workspaces.nav.anketa")}
            </ButtonLink>
            <ButtonLink to="/account/notifications" variant="navMobile" className="nav-menu-link !after:hidden" onClick={onItemClick}>
              {t("nav.notifications")}
            </ButtonLink>
          </div>
        ) : null}
        <div className="mt-3 pt-3 border-t border-lib-border">
          {auth.isAuthenticated ? (
            <ButtonLink
              variant="navMobile"
              className="!after:hidden text-gray-600"
              onClick={() => {
                onItemClick()
                auth.logout()
              }}
            >
              {t("nav.logout")}
            </ButtonLink>
          ) : (
            <ButtonLink
              variant="navMobileAccent"
              onClick={() => {
                onItemClick()
                auth.login(CABINET_ENTRY_PATH)
              }}
            >
              {t("nav.login")}
            </ButtonLink>
          )}
        </div>
      </div>
    )
  },
)
NavbarMobileMenu.displayName = "NavbarMobileMenu"
